import AssigneePicker from "@/components/PersonPickerDropdown/assigneePicker.component";
import { useUser } from "@/hooks/AppContext/user.hook";
import { User } from "lucide-react";
import React, { useMemo } from "react";

type TaskCellAssigneeProps = {
  className: string;
  editedAssignedTo?: number;
  editing: boolean;
  assignedTo: number | null;
  handleFieldAssignedTo?: (id: number) => void;
  isOpen?: React.MutableRefObject<boolean>;
};

const TaskCellAssignee: React.FC<TaskCellAssigneeProps> = ({
  className,
  editedAssignedTo,
  editing,
  assignedTo,
  handleFieldAssignedTo,
  isOpen,
}) => {
  const { getUserFullNameByID, getUserProfileImageByID } = useUser();

  const assignedImage = useMemo(() => {
    return assignedTo
      ? getUserProfileImageByID(
          editedAssignedTo ? editedAssignedTo : assignedTo
        )
      : null;
  }, [assignedTo, editedAssignedTo, getUserProfileImageByID]);

  return editing && editedAssignedTo && handleFieldAssignedTo && isOpen ? (
    <div className={className}>
      <AssigneePicker
        assignedTo={editedAssignedTo}
        handleFieldAssignedTo={handleFieldAssignedTo}
        isOpen={isOpen}
        modal={false}
      />
    </div>
  ) : (
    <div className={className}>
      {assignedTo ? (
        <div className="flex items-center gap-1">
          {assignedImage ? (
            <img className="size-4 rounded-full shrink-0" src={assignedImage} />
          ) : (
            <User className="size-4 rounded-full bg-primary shrink-0" />
          )}

          {getUserFullNameByID(
            editedAssignedTo ? editedAssignedTo : assignedTo
          )}
        </div>
      ) : (
        <>Not assigned</>
      )}
    </div>
  );
};

export default TaskCellAssignee;
